import { useEffect, useRef, useState } from "react";
import BPService from "../../services/resource/bpService";
import DashboardLineChart from "./dashboards/DashboardLineChart";
import ContaContabilBarChart from "./dashboards/ContaContabilBarChart";
import './styles.css'
import { Sidebar } from "primereact/sidebar";
import DashboardLinePointChart from "./dashboards/DashboardLinePointChart";
import DashboardBar from "./dashboards/DashboardBar";
import DespesaService from "../../services/resource/DespesaService";
import { copyElementToClipboard } from "../../utils/copyElementToClipboard";
import BPxRealizadoTabela from "./dashboards/BPxRealizadoTabela";
import BPxRealizadoTabelaMeses from "./dashboards/BPxRealizadoTabelaMeses";
import { ChartCard } from "../../componentes/chart/CardChart";
import { KPICard } from "../../componentes/chart/KPICard";
import DropdownButton from "../../componentes/dropdown/newDropdown";
import { exportDashboardToPDF } from "../../utils/exportarDashboardEmPDF";
import { captureElementToImage } from "../../utils/captureElementToImage";
import { CustomMultiSelect } from "../../componentes/multiselect/CustomMultiSelect";
import { MESES } from "../../utils/options";
import ReceitaService from "../../services/resource/ReceitaService";
import { Dialog } from "primereact/dialog";
import ProcessoSincronizacaoService from "../../services/resource/ProcessoSincronizacaoService";
import { toast } from "react-toastify";
import { exportarRelatorioBPExcel } from "./dashboards/exportarRelatorioBPExcel";
import TabelaPrevistoRealizado from "./dashboards/tabelaPrevistoXRealizado"

const C = {
    bg: "#F0F4F8",
    surface: "#FFFFFF",
    surfaceAlt: "#F8FAFC",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    primary: "#0EA5E9",
    primaryDark: "#0284C7",
    secondary: "#6366F1",
    accent: "#10B981",
    danger: "#EF4444",
    warn: "#F59E0B",
    purple: "#8B5CF6",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    c1: "#0EA5E9",
    c2: "#6366F1",
    c3: "#10B981",
    c4: "#F59E0B",
    c5: "#EF4444",
};

const initialRelatorioKpi = {
    "totalOrcado": 0,
    "totalRealizado": 0,
    "saldo": 0,
    "tendencia": 0,
    "mediaOrcado": 0,
    "mediaRealizado": 0,
    "economia": 0,
    "lucroAnual": 0,
    "porcentagemEconomia": 0,
    "porcentagemLucroAnual": 0
}

const initialRelatorioTotais = {
    "totalOrcadoMensal": {},
    "totalRealizadoMensal": {},
    "totalRealizadoMensalAnterior": {},
    "totalPorCentroCusto": {},
    "totalPorContaContabil": {},
    "totalOrcadoPorCentroCusto": {},
    "totalRealizadoPorCentroCustoAnterior": {},
    "totalRealizadoPorCentroCusto": {},
    "totalOrcadoPorContaContabil": {},
    "totalRealizadoPorContaContabil": {},
    "totalRealizadoPorContaContabilAnterior": {},
    "totalOrcadoPorResponsavel": {},
    "totalRealizadoPorResponsavel": {},
    "totalOrcadoPorFilial": {},
    "totalRealizadoPorFilial": {},
    "totalRealizadoPorFilialAnterior": {},
    "totalOrcadoPorTipo": {},
    "totalRealizadoPorTipo": {},
    "totalOrcadoPorGrupo": {},
    "totalRealizadoPorGrupo": {},
    "totalRealizadoPorGrupoAnterior": {},
    "totalRealizadoPorResponsavelAnterior": {},
    "totalRealizadoPorTipoAnterior": {}
}


const initialVolume = {
    "caixasUnitariasEntregues": null,
    "caixasFisicasEntregues": null,
    "cubosEntregues": null,
    "caixasUnitariasRetornados": null,
    "caixasFisicasRetornados": null,
    "cubosRetornados": null,
}

function BPRelatorio() {
    const bpService = new BPService();
    const psService = new ProcessoSincronizacaoService();
    const despesaService = new DespesaService();
    const receitaService = new ReceitaService();

    const { selectedFilters, handleChange, clearFilters, hasFilters } = useFiltrosPersistentes("filtrosBP");

    const [log, setLog] = useState({});
    const [atualizarLista, setAtualizarLista] = useState(false);
    const [relatorioKpi, setRelatorioKpi] = useState(initialRelatorioKpi);
    const [relatorioTotais, setRelatorioTotais] = useState(initialRelatorioTotais);
    const [relatorioVolume, setRelatorioVolume] = useState(initialVolume);
    const [relatorioReceita, setRelatorioReceita] = useState(null);
    const [dialogAtualizacaoOpen, setDialogAtualizacaoOpen] = useState(false);
    const [sincronizacoes, setSincronizacoes] = useState([]);
    const [loadingSincronizacao, setLoadingSincronizacao] = useState(false);
    const [viewTipo, setViewTipo] = useState("chart");
    const [viewMensal, setViewMensal] = useState("chart");
    const [viewCentro, setViewCentro] = useState("chart");
    const [viewFilial, setViewFilial] = useState("chart");
    const [viewConta, setViewConta] = useState("chart");
    const [viewResponsavel, setViewResponsavel] = useState("chart");
    const [viewGrupo, setViewGrupo] = useState("chart");
    const [loading, setLoading] = useState(true);
    const [loadingKPI, setLoadingKPI] = useState(true);
    const [loadingReceita, setLoadingReceita] = useState(true);
    const [loadingVolume, setLoadingVolume] = useState(true);
    const [loadingFiltros, setLoadingFiltros] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [modoVisualizacao, setModoVisualizacao] = useState('table');
    const [filtros, setFiltros] = useState({
        "centroCusto": [],
        "contaContabil": [],
        "filial": [],
        "responsavel": [],
        "tipo": [],
        "ano": [],
        "mes": [],
    });

    useEffect(() => {
        fetchRelatorio();
        fetchFiltros();

        despesaService.log().then(response => {
            setLog(response.data);
        });

        document.title = "MyDash | Acompanhamento Logístico"
    }, []);

    const primeiraExecucao = useRef(true);

    useEffect(() => {
        if (primeiraExecucao.current) {
            primeiraExecucao.current = false;
            return;
        }

        const debounce = setTimeout(() => {
            fetchRelatorio();
            setAtualizarLista((prev) => !prev);
        }, 1000);

        return () => clearTimeout(debounce);
    }, [selectedFilters]);

    const fetchSincronizacoes = async () => {

        try {

            setLoadingSincronizacao(true);

            const response = await psService.buscarRelatorioBP();

            setSincronizacoes(response.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoadingSincronizacao(false);
        }
    }

    const fetchRelatorio = () => {
        fetchKPI();
        if (modoVisualizacao === "chart") fetchTotais();
        fetchVolume();
        //fetchReceita();
    }

    const fetchTotais = () => {
        setLoading(true);

        bpService.relatorioTotais(selectedFilters)
            .then(res => setRelatorioTotais(res.data))
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    }

    const fetchKPI = () => {
        setLoadingKPI(true);

        bpService.relatorioKpi(selectedFilters)
            .then(res => setRelatorioKpi(res.data))
            .catch(error => console.error(error))
            .finally(() => setLoadingKPI(false));
    }

    const fetchVolume = () => {
        setLoadingVolume(true);

        bpService.relatorioVolume(selectedFilters)
            .then(res => setRelatorioVolume(res.data))
            .catch(error => console.error(error))
            .finally(() => setLoadingVolume(false));
    }

    const fetchReceita = () => {
        setLoadingReceita(true);

        receitaService.relatorioReceita(selectedFilters)
            .then(res => setRelatorioReceita(res.data))
            .catch(error => console.error(error))
            .finally(() => setLoadingReceita(false));
    }

    const handleChartFilterClick = (chave, valor) => {
        if (valor === null || valor === undefined || valor === "") return;

        const atual = selectedFilters[chave] ?? [];
        const jaSelecionado = atual.includes(valor);

        handleChange(
            chave,
            jaSelecionado ? atual.filter((v) => v !== valor) : [...atual, valor]
        );

        toast.info(jaSelecionado ? `Filtro removido: ${valor}` : `Filtro adicionado: ${valor}`);
    };

    const fetchFiltros = () => {
        setLoadingFiltros(true);
        bpService.filtrosBP(selectedFilters, 2026).then(response => {
            setFiltros(response.data);
        }).catch(error => {
            console.error(error)
        }).finally(() => {
            setTimeout(() => {
                setLoadingFiltros(false)
            }, 100)
        })
    };

    const exportDashboardExcel = () => {
        const toastId = toast.loading("Gerando relatório, isso pode levar alguns segundos...");

        bpService.exportDashboardExcel(selectedFilters)
            .then(response => exportarRelatorioBPExcel(response.data, {
                ano: selectedFilters?.ano,
                mesesSelecionados: selectedFilters?.mes || [],
            }))
            .then(() => toast.update(toastId, { render: "Relatório gerado!", type: "success", isLoading: false, autoClose: 3000 }))
            .catch(() => toast.update(toastId, { render: "Erro ao gerar relatório", type: "error", isLoading: false, autoClose: 4000 }))
    };

    const dropdownItem = {
        width: "100%",
        border: "none",
        padding: "10px 14px",
        textAlign: "left",
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "var(--font-sans)",
        display: "flex",
        alignItems: "center",
        gap: 8
    };

    const formatarProcesso = (processo) => {

        const nomes = {
            ENTREGA_VOLUME_SAP: "Volume Entregas",
            RETORNO_VOLUME_SAP: "Volume Retornos",
            DESPESA_FORTESAC: "Despesa Logística",
            DESPESA_BI: "Despesa Distribuidores",
            RECEITA_BI: "Receita Distribuidores",
            RECEITA_FORTESAC: "Receita Logística",
        };

        return nomes[processo] || processo;
    }

    function timeAgo(date) {
        if (!date) return "—";

        const diff = Math.floor((Date.now() - new Date(date)) / 1000);

        if (diff < 60) return `há ${diff}s`;
        if (diff < 3600) return `há ${Math.floor(diff / 60)}min`;
        if (diff < 86400) return `há ${Math.floor(diff / 3600)}h`;

        return `há ${Math.floor(diff / 86400)}d`;
    }

    function HintClicavel() {
        return (
            <span className="ml-1 text-[10px] text-muted-foreground font-normal normal-case tracking-normal">
                (clique para filtrar)
            </span>
        );
    }

    function HintClicavelCtrl() {
        return (
            <span className="ml-1 text-[10px] text-muted-foreground font-normal normal-case tracking-normal">
                (clique + CTRL para filtrar)
            </span>
        );
    }

    return (
        <div className="font-sans min-h-screen" style={{ background: C.bg, color: C.text }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, background: C.surface, padding: "0 24px", height: 58 }}>
                <div className="font-display" style={{
                    width: 34, height: 34, background: C.primary, borderRadius: 9,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 13, fontWeight: 800, color: "#fff", letterSpacing: -.5,
                }}>BP</div>
                <div>
                    <div className="font-display" style={{ fontSize: 14, fontWeight: 700, color: C.text, lineHeight: 1.2 }}>
                        Acompanhamento Orçamentário
                    </div>
                    <div style={{ fontSize: 11, color: C.muted }}>Budget Plan · Visão gerencial</div>
                </div>
            </div>
            <div className="sticky top-0 z-[100] flex items-center justify-between shadow-xs" style={{
                background: C.surface, borderBottom: `1px solid ${C.border}`,
                padding: "0 24px", height: 58,
            }}>
                <div className="flex gap-3 justify-center mb-3 mt-3">
                    {[
                        { key: 'table', icon: 'fa-table', label: 'Ver Tabela', onClick: () => setModoVisualizacao('table') },
                        { key: 'chart', icon: 'fa-chart-line', label: 'Ver Dashboard', onClick: () => { fetchTotais(); setModoVisualizacao('chart'); } },
                        { key: 'comparativo', icon: 'fa-external-link', label: 'Comparativo 2026.1 vs 2026.2', onClick: () => { window.open('/bp/comparativo', '_blank', 'noopener,noreferrer'); } },
                        { key: 'volume', icon: 'fa-external-link', label: 'Volume Logístico', onClick: () => { window.open('/dashboard-entregas-retornos', '_blank', 'noopener,noreferrer'); } },
                    ].map(({ key, icon, label, onClick }) => {
                        const active = modoVisualizacao === key;
                        return (
                            <button
                                key={key}
                                onClick={onClick}
                                className="h-8 px-3.5 rounded-lg text-xs font-semibold border-[1.5px] duration-150"
                                style={{
                                    background: active ? C.primary : C.surfaceAlt,
                                    border: `1.5px solid ${active ? C.primary : C.border}`,
                                    color: active ? "#fff" : C.textMid,
                                    boxShadow: active ? "0 4px 12px rgba(37,99,235,.25)" : "none",
                                    transform: active ? "translateY(-1px)" : "translateY(0)",
                                }}
                            >
                                <i className={`fa ${icon}`} /> {label}
                            </button>
                        );
                    })}

                </div>

                <div className="flex items-center gap-2">

                    {hasFilters && (
                        <button
                            onClick={clearFilters}
                            className="h-8 px-3.5 rounded-lg text-xs font-semibold border-[1.5px] transition-colors duration-150 hover:bg-destructive/5"
                            style={{ background: "transparent", borderColor: C.danger, color: C.danger }}
                        >✕ Limpar filtros</button>
                    )}

                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="h-8 px-3.5 rounded-lg text-xs font-semibold border-[1.5px] transition-colors duration-150 hover:brightness-95"
                        style={{ background: C.surfaceAlt, borderColor: C.border, color: C.textMid }}
                    ><i className="fa fa-filter" /> Filtros</button>

                    <button
                        onClick={() => { fetchRelatorio(); setAtualizarLista(!atualizarLista) }}
                        className="h-8 px-3.5 rounded-lg text-xs font-semibold border-[1.5px] transition-colors duration-150 hover:brightness-95"
                        style={{ background: C.surfaceAlt, borderColor: C.border, color: C.textMid }}
                    >↻ Atualizar</button>

                    {/* Dropdown Exportar */}
                    <DropdownButton
                        trigger={
                            <button
                                className="h-8 px-3.5 rounded-lg text-xs font-semibold border-[1.5px] transition-colors duration-150 hover:brightness-95"
                                style={{ background: C.surfaceAlt, borderColor: C.border, color: C.textMid }}
                            >
                                <i className="fa fa-download" /> Exportar
                                <i className="fa fa-caret-down ml-1" />
                            </button>
                        }
                    >
                        {(onclose) => (
                            <>
                                <button
                                    onClick={() => {
                                        if (modoVisualizacao === "table") {
                                            toast.warn("Não é possível baixar a imagem no modo tabela!");

                                            return;
                                        }
                                        copyElementToClipboard("bpContainer"); onclose()
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-clipboard" /> Copiar Imagem
                                </button>


                                <button
                                    onClick={() => {
                                        if (modoVisualizacao === "table") {
                                            toast.warn("Não é possível baixar a imagem no modo tabela!");

                                            return;
                                        }

                                        captureElementToImage("bpContainer");
                                        onclose()
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-image" /> Baixar Imagem
                                </button>

                                <button
                                    onClick={() => {
                                        exportDashboardExcel();
                                        onclose()
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-file-excel" /> Excel
                                </button>

                                <button
                                    onClick={() => {
                                        if (modoVisualizacao === "table") {
                                            toast.warn("Não é possível baixar a imagem no modo tabela!");

                                            return;
                                        }

                                        const dataAtual = new Date();
                                        const title = "Acompanhamento BP "

                                        const subtitle = "Relatório emitido em " + dataAtual.toLocaleDateString + ' ' + dataAtual.toLocaleTimeString()

                                        exportDashboardToPDF(
                                            ['bpContainer1', 'bpContainer2'],
                                            title,
                                            subtitle
                                        );

                                        onclose();

                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-file-pdf" /> Download PDF
                                </button>

                                <button
                                    onClick={() => {
                                        setDialogAtualizacaoOpen(true);
                                        fetchSincronizacoes();
                                        onclose();

                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-sync-alt" /> Verificar Atualizações
                                </button>
                            </>
                        )}
                    </DropdownButton>
                </div>
            </div>
            <main className="px-4 py-6">
                <Sidebar
                    blockScroll={true}
                    visible={sidebarOpen}
                    onHide={() => setSidebarOpen(false)}
                    className="w-[70vw] lg:w-[40vw]"
                >
                    {/* Empresa */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        {/* Ano */}
                        <div className="flex flex-col">
                            <label className="text-xs text-muted-foreground font-medium flex items-center gap-2 mb-1">
                                <i className="fa fa-calendar text-muted-foreground"></i> Ano
                            </label>
                            <CustomMultiSelect
                                value={selectedFilters.ano}
                                onChange={(val) => handleChange("ano", val)}
                                options={(filtros.ano ?? []).map((v) =>
                                    typeof v === "object" ? v : { label: String(v), value: v }
                                )}
                                disabled={loadingFiltros}
                                filterPlaceholder="Buscar..."
                            />
                        </div>

                        {/* Mês — novo filtro */}
                        <div className="flex flex-col">
                            <label className="text-xs text-muted-foreground font-medium flex items-center gap-2 mb-1">
                                <i className="fas fa-calendar-alt text-muted-foreground"></i> Mês
                            </label>
                            <CustomMultiSelect
                                value={selectedFilters.mes}
                                onChange={(val) => handleChange("mes", val)}
                                options={MESES}
                                disabled={loadingFiltros}
                                filterPlaceholder="Buscar..."
                            />
                        </div>
                    </div>

                    <div className="grid gap-4">
                        {renderMultiSelect("Responsável", "responsavel", filtros.responsavel, "fa-user", selectedFilters, handleChange, loadingFiltros)}
                        {renderMultiSelect("Filial", "filial", filtros.filial, "fa-map-marker-alt", selectedFilters, handleChange, loadingFiltros)}
                        {renderMultiSelect("Centro de Custo", "centroCusto", filtros.centroCusto, "fa-building", selectedFilters, handleChange, loadingFiltros, mapCentroCusto)}
                        {renderMultiSelect("Conta Contábil", "contaContabil", filtros.contaContabil, "fa-book", selectedFilters, handleChange, loadingFiltros, mapContaContabil, true)}
                        {renderMultiSelect("Tipo", "tipo", filtros.tipo, "fa-tags", selectedFilters, handleChange, loadingFiltros)}
                    </div>

                    <div className="mt-4 flex gap-2 px-3">
                        <button
                            onClick={() => {
                                fetchRelatorio();
                                setSidebarOpen(false);
                                setAtualizarLista(!atualizarLista)
                            }}
                            className="flex items-center gap-2 h-9 px-4 bg-primary hover:brightness-95 text-primary-foreground text-sm font-medium rounded-lg shadow-xs transition-all duration-150"
                        >
                            <i className="fas fa-filter"></i> Aplicar
                        </button>
                        <button
                            onClick={clearFilters}
                            className="flex items-center gap-2 h-9 px-4 bg-muted hover:bg-muted/70 text-foreground text-sm font-medium rounded-lg shadow-xs transition-all duration-150"
                        >
                            <i className="fas fa-times"></i> Limpar
                        </button>
                    </div>
                </Sidebar>



                <div id="bpContainer">
                    {/* Cards resumo */}
                    {/* <DashboardResumo relatorio={relatorio} isLoading={loading} tendencia={relatorio.tendencia} /> */}

                    <div id="bpContainer1" className="animate-in grid lg:grid-cols-4 md:grid-cols-4 gap-3 repeat(auto-fill, minmax(190px, 1fr))">
                        <KPICard label="Orçado" value={fmt(relatorioKpi?.totalOrcado)} color={C.c1} icon="📋" loading={loadingKPI} sub={fmt(relatorioKpi?.mediaOrcado) + ' média mensal'} />
                        <KPICard label="Realizado" value={fmt(relatorioKpi?.totalRealizado)} sub={fmt(relatorioKpi?.mediaRealizado) + ' média mensal'} color={C.c3} icon="✅" loading={loadingKPI} />
                        <KPICard label="Disponível" value={fmt(relatorioKpi?.saldo)} color={C.textMid} icon="💰" pct={relatorioKpi?.porcentagemEconomia} loading={loadingKPI} />
                        <KPICard label="Forecast" value={fmt(relatorioKpi?.forecastAnual)} color={C.c2} icon="🔮" sub={'Saldo ' + fmt(relatorioKpi?.totalOrcado - relatorioKpi?.forecastAnual)} loading={loadingKPI} />
                        <KPICard label="Tendência" value={selectedFilters?.mes?.length >= 1 ? '-' : fmt(relatorioKpi?.tendencia)} color={C.c2} icon="📈" sub={selectedFilters?.mes?.length >= 1 ? '' : 'Economia de ' + fmt(relatorioKpi?.lucroAnual)} loading={loadingKPI} />
                        <KPICard label="Volume" value={fmtNumero(relatorioVolume?.volume)} color={C.muted} icon="📦" sub={
                            <a href="/dashboard-entregas-retornos" target="_blank">
                                Ver detalhes volume logístico
                            </a>

                        } loading={loadingVolume} />
                        <KPICard label="Receita Operacional" value={fmt(relatorioVolume?.receitaOperacional)} sub={'Receita Bruta ' + fmt(relatorioVolume?.receitaBruta)} color={C.muted} icon="🏦" loading={loadingVolume} />
                        <KPICard label="Margem" value={fmtNumero(relatorioVolume?.margem) + '%'} color={C.primary} icon="💵" loading={loadingVolume} />
                    </div>

                    {modoVisualizacao === 'chart' ?

                        <div className="flex flex-col gap-4 lg:grid lg:grid-cols-12 mb-2 mt-3">
                            <div id="bpContainer2" className="lg:col-span-12">
                                <ChartCard
                                    title={<>Evolução Mensal — Orçado × Realizado × Ano Anterior <HintClicavelCtrl /> </>}
                                    view={viewMensal}
                                    onViewChange={setViewMensal}
                                    accent={C.c1}
                                    tableContent={
                                        <BPxRealizadoTabelaMeses
                                            orcadoObj={relatorioTotais?.totalOrcadoMensal}
                                            realizadoObj={relatorioTotais?.totalRealizadoMensal}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoMensalAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardLineChart
                                        relatorio={relatorioTotais}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(label) => { handleChartFilterClick("mes", label) }} />

                                </ChartCard>
                            </div>
                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por filial <HintClicavel /></>} view={viewFilial} onViewChange={setViewFilial} accent={C.c2}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorFilial}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorFilial}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorFilialAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardBar
                                        orcadoObj={relatorioTotais?.totalOrcadoPorFilial}
                                        realizadoObj={relatorioTotais?.totalRealizadoPorFilial}
                                        realizadoObjAnterior={relatorioTotais?.totalRealizadoPorFilialAnterior}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(label) => handleChartFilterClick("filial", label)} />
                                </ChartCard>
                            </div>

                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por filial <HintClicavel /></>} view={viewCentro} onViewChange={setViewCentro} accent={C.accent}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorCentroCusto}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorCentroCusto}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorCentroCustoAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardBar
                                        orcadoObj={relatorioTotais?.totalOrcadoPorCentroCusto}
                                        realizadoObj={relatorioTotais?.totalRealizadoPorCentroCusto}
                                        realizadoObjAnterior={relatorioTotais?.totalRealizadoPorCentroCustoAnterior}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(label) => handleChartFilterClick("centroCusto", label)} />
                                </ChartCard>
                            </div>

                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por Responsável <HintClicavel /></>} view={viewResponsavel} onViewChange={setViewResponsavel} accent={C.warn}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorResponsavel}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorResponsavel}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorResponsavelAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardBar
                                        orcadoObj={relatorioTotais?.totalOrcadoPorResponsavel}
                                        realizadoObj={relatorioTotais?.totalRealizadoPorResponsavel}
                                        realizadoObjAnterior={relatorioTotais?.totalRealizadoPorResponsavelAnterior}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(label) => handleChartFilterClick("responsavel", label)} />
                                </ChartCard>
                            </div>

                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por Tipo Despesa <HintClicavel /></>} view={viewTipo} onViewChange={setViewTipo} accent={C.c2}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorTipo}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorTipo}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorTipoAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardBar
                                        orcadoObj={relatorioTotais?.totalOrcadoPorTipo}
                                        realizadoObj={relatorioTotais?.totalRealizadoPorTipo}
                                        realizadoObjAnterior={relatorioTotais?.totalRealizadoPorTipoAnterior}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(label) => handleChartFilterClick("tipo", label)} />
                                </ChartCard>
                            </div>

                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por Grupo <HintClicavel /></>} view={viewGrupo} onViewChange={setViewGrupo} accent={C.c2}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorGrupo}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorGrupo}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorGrupoAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <DashboardLinePointChart
                                        orcadoObj={relatorioTotais?.totalOrcadoPorGrupo}
                                        realizadoObj={relatorioTotais?.totalRealizadoPorGrupo}
                                        realizadoObjAnterior={relatorioTotais?.totalRealizadoPorGrupoAnterior}
                                        ano={selectedFilters?.ano}
                                        loading={loading} />
                                </ChartCard>
                            </div>

                            <div className="lg:col-span-6">
                                <ChartCard title={<>Por Conta Contábil <HintClicavelCtrl /></>} view={viewConta} onViewChange={setViewConta} accent={C.c4}
                                    tableContent={
                                        <BPxRealizadoTabela
                                            orcadoObj={relatorioTotais?.totalOrcadoPorContaContabil}
                                            realizadoObj={relatorioTotais?.totalRealizadoPorContaContabil}
                                            realizadoObjAnterior={relatorioTotais?.totalRealizadoPorContaContabilAnterior}
                                            loading={loading}
                                            ano={selectedFilters?.ano}
                                        />
                                    }
                                >
                                    <ContaContabilBarChart
                                        relatorio={relatorioTotais}
                                        ano={selectedFilters?.ano}
                                        loading={loading}
                                        onBarClick={(reduzido) => handleChartFilterClick("contaContabil", reduzido)} />
                                </ChartCard>
                            </div>
                        </div>
                        :
                        <TabelaPrevistoRealizado selectedFilters={selectedFilters} atualizar={atualizarLista} />
                    }
                </div>

            </main >

            <Dialog
                header="Últimas Atualizações BP"
                visible={dialogAtualizacaoOpen}
                onHide={() => setDialogAtualizacaoOpen(false)}
                style={{ width: "750px", maxWidth: "95vw" }}
                draggable={false}
                resizable={false}
            >

                <div className="flex flex-col gap-3 pt-3">

                    {loadingSincronizacao && (
                        <div className="text-sm text-muted-foreground">
                            Carregando sincronizações...
                        </div>
                    )}

                    {!loadingSincronizacao && sincronizacoes?.map((item, index) => {

                        const sucesso = !item.erro;

                        return (
                            <div
                                key={index}
                                className="border border-border rounded-xl p-4 flex items-center justify-between bg-card shadow-xs"
                            >

                                <div className="flex flex-col gap-1">

                                    <div className="flex items-center gap-2">

                                        <span
                                            className={`w-2.5 h-2.5 rounded-full bg-green-500`}
                                        />

                                        <span className="font-semibold text-sm text-foreground">
                                            {formatarProcesso(item.processo)}
                                        </span>

                                    </div>

                                    <span className="text-xs text-muted-foreground">
                                        {item.inicio
                                            ? timeAgo(item.inicio)
                                            : "Nunca sincronizado"}
                                    </span>

                                </div>

                                <div className="flex flex-col items-end">

                                    <span
                                        className="text-xs font-bold px-2 py-1 rounded-full bg-green-100 text-green-700"
                                    >
                                        SINCRONIZADO
                                    </span>
                                </div>

                            </div>
                        );
                    })}
                </div>
            </Dialog>
        </div >
    );
}

export default BPRelatorio;


export const useFiltrosPersistentes2 = (chaveLocal = "filtrosBP") => {
    const [selectedFilters, setSelectedFilters] = useState(() => {
        try {
            const salvo = localStorage.getItem(chaveLocal);
            return salvo ? JSON.parse(salvo) : {};
        } catch {
            return {};
        }
    });

    useEffect(() => {
        localStorage.setItem(chaveLocal, JSON.stringify(selectedFilters));
    }, [selectedFilters, chaveLocal]);

    const handleChange = (key, value) => {
        setSelectedFilters((prev) => ({ ...prev, [key]: value }));
    };

    const clearFilters = () => {
        setSelectedFilters({});
        localStorage.removeItem(chaveLocal);
    };

    const hasFilters = Object.values(selectedFilters).some((v) => v && v !== "");

    return { selectedFilters, handleChange, clearFilters, hasFilters };
};

export const useFiltrosPersistentes = (chaveLocal = "filtrosBP") => {
    const initialState = {
        responsavel: [],
        filial: [],
        centroCusto: [],
        contaContabil: [],
        tipo: [],
        logistico: [1, 0, 2],
        ano: [2026],
        mes: [],
    };

    const [selectedFilters, setSelectedFilters] = useState(() => {
        try {
            const salvo = localStorage.getItem(chaveLocal);
            return salvo ? JSON.parse(salvo) : initialState;
        } catch {
            return initialState;
        }
    });

    useEffect(() => {
        localStorage.setItem(chaveLocal, JSON.stringify(selectedFilters));
    }, [selectedFilters, chaveLocal]);

    const handleChange = (key, value) => {
        setSelectedFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const clearFilters = () => {
        setSelectedFilters(initialState);
        localStorage.removeItem(chaveLocal);
    };

    const hasFilters = JSON.stringify(selectedFilters) !== JSON.stringify(initialState);

    return { selectedFilters, handleChange, clearFilters, hasFilters };
};

export const renderMultiSelect = (
    label,
    key,
    values,
    icon,
    selectedFilters,
    handleChange,
    loadingFiltros,
    optionMapper = null,
    virtualize = false,
) => {
    const options = optionMapper
        ? optionMapper(values ?? [])
        : (values ?? [])
            .filter((v) => v !== null && v !== "")
            .map((v) =>
                typeof v === "object" && v.label !== undefined
                    ? v
                    : { label: String(v), value: v }
            );

    return (
        <div className="flex flex-col mb-2" key={key}>
            <label className="text-xs text-muted-foreground font-medium flex items-center gap-2 mb-1">
                <i className={`fas ${icon} text-muted-foreground`}></i> {label}
            </label>
            <CustomMultiSelect
                value={selectedFilters[key] ?? []}
                onChange={(val) => handleChange(key, val)}
                options={options}
                disabled={loadingFiltros}
                emptyMessage="Nenhuma opção a exibir"
                filterPlaceholder="Buscar..."
                virtualize={virtualize}
            />
        </div>
    );
};

const fmtNumero = (v) =>
    new Intl.NumberFormat("pt-BR", {
        currency: "BRL",
        maximumFractionDigits: 2,
    }).format(v ?? 0);

const fmt = (v) =>
    new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        maximumFractionDigits: 2,
    }).format(v ?? 0);

export const mapContaContabil = (list = []) =>
    list
        .filter((v) => v != null)
        .map((v) => ({
            label: `${v.reduzido} – ${v.descricao}`,
            value: v.reduzido,
        }));

export const mapCentroCusto = (list = []) =>
    list
        .filter((v) => v != null)
        .map((v) => ({
            label: `${v.codigo} – ${v.descricao}`,
            value: v.codigo,
        }));